export const PAGE_SCG_LIVE = [
  '100684322285177',
  '100378482209868',
  '109181747969457',
  '769473233454900'
]
